export const HEADER_LEFT_COL = {
  span: 12,
  xs: 24,
  sm: 24,
  md: 8,
  lg: 8,
  xl: 8,
  xxl: 8
};

export const HEADER_RIGHT_COL = {
  span: 12,
  xs: 24,
  sm: 24,
  md: 16,
  lg: 16,
  xl: 16,
  xxl: 16
};
